import { getBase64, getImageSrc } from './mediaSDK.js'

export default {
  getBase64,
  getImageSrc,
}
